import { useMutation } from "@tanstack/react-query";
import { createAcademicYear as apiCreate } from "../../api/apiAcademicYears";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateAcademicYear() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: createAcademicYear, isPending, data: results, error } = useMutation({
        mutationFn: (req) => apiCreate(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            navigate('/academic-years');
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { isPending, error, createAcademicYear, results };
}
